import React from "react";

const icon = (props) => (
  <i
    className={props.iconClass}
    style={{ color: props.color }}
    aria-hidden="true"
  >
    {props.children}
  </i>
);

export default icon;
